export const SAVE_PAYMENT_DATA = 'SAVE_PAYMENT_DATA'
export const SAVE_PAYMENT_DATA_SUCCESS = 'SAVE_PAYMENT_DATA_SUCCESS'
export const SAVE_PAYMENT_DATA_FAIL = 'SAVE_PAYMENT_DATA_FAIL'

export const savePaymentData = (params) => {
    return { type: SAVE_PAYMENT_DATA, params }
}
 